import { render, staticRenderFns } from "./PosOperationDetails.vue?vue&type=template&id=28658255&"
import script from "./PosOperationDetails.vue?vue&type=script&lang=js&"
export * from "./PosOperationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports